import { put, takeLatest } from 'redux-saga/effects';
import { emdProductBucketEndPoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import {
  fetchBucketsFailure,
  fetchBucketsRequest,
  fetchBucketsSuccess,
  fetchProductsFailure,
  fetchProductsRequest,
  fetchProductsSuccess,
} from '../../slice/agency-onbording/ProductBucket.slice';

// Product Sagas
function* fetchProductsSaga(): Generator<any, void, any> {
  try {
    const response = yield HTTPClient.GetRequest(
      emdProductBucketEndPoints.GET_ALL_PRODUCTS
    );
    if (response && response.status === 200) {
      yield put(fetchProductsSuccess(response.data));
    } else {
      yield put(fetchProductsFailure('Something went wrong!'));
    }
  } catch (error) {
    yield put(fetchProductsFailure('Something went wrong!'));
  }
}

// Bucket Sagas
function* fetchBucketsSaga(): Generator<any, void, any> {
  try {
    const response = yield HTTPClient.GetRequest(
      emdProductBucketEndPoints.GET_ALL_BUCKETS
    );
    if (response && response.status === 200) {
      yield put(fetchBucketsSuccess(response.data));
    } else {
      yield put(fetchBucketsFailure('Something went wrong!'));
    }
  } catch (error) {
    yield put(fetchBucketsFailure('Something went wrong!'));
  }
}

// Root saga
export function* productBucketSaga() {
  yield takeLatest(fetchProductsRequest.type, fetchProductsSaga);
  yield takeLatest(fetchBucketsRequest.type, fetchBucketsSaga);
}
